import { Directive, ElementRef, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appDisableClickEvent]'
})
export class DisableClickEventDirective implements OnInit {

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.storyblok?.pingEditor(() => {
        if (window.storyblok.isInEditor()) {
          this.el.nativeElement.style['pointer-events'] = 'none';
          this.el.nativeElement.disabled = 'true';
        }
      });
    }
  }
}

// Storyblok Directive
// _____________________
//
// Will disable click events from anchors and buttons when site is loaded from content editor.
// Needed for avoiding navigation or unexpected behaviors in editor
